module.exports = __webpack_public_path__ + "media/images/jk_w-8be4d5a1ecb0918c7407fb11a93328d0.png";